import { Controller } from 'stimulus'
import Sortable from 'sortablejs'
import { request } from './request'

// A row moves within its status section, never across.
export default class extends Controller {
  static targets = ['body']

  connect() {
    this.sortables = this.bodyTargets.map(body => Sortable.create(body, {
      handle:     '[data-fr-handle]',
      draggable:  '[data-fr-row]',
      animation:  160,
      ghostClass: 'fr-row--ghost',
      onEnd:      event => this.persist(event.to),
    }))
  }

  disconnect() {
    (this.sortables || []).forEach(sortable => sortable.destroy())
  }

  persist(body) {
    body.querySelectorAll('[data-fr-row]').forEach((row, index) => {
      const rank = row.querySelector('[data-fr-rank]')
      if (rank) rank.textContent = index + 1
    })
    const ids = [...this.element.querySelectorAll('[data-fr-row]')].map(row => row.dataset.frRow)
    request('/feature_requests/reorder', { method: 'PATCH', body: { ids } })
  }
}
